import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M66 0H0.300049V25.8H66V0Z" fill="#338AF3" />
    <path d="M66 25.9H0.300049V51H66V25.9Z" fill="#FFDA44" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
